import { Stack, IconButton } from "@mui/material"
import { Delete } from "@mui/icons-material"
import { grey } from "@mui/material/colors"

type DeleteBarProps = {
  onDelete?: () => void
  title: string
}

export default function DeleteBar({ onDelete, title }: DeleteBarProps) {
  return (
    <Stack direction={"row"} alignItems={"center"} sx={{ p: 2 }} spacing={1}>
      <IconButton
        onClick={onDelete}
        sx={{
          background: grey[300],
          color: "action.active",
          "&:hover": { background: 'error.main', color: "error.dark" },
        }}
        aria-label={title ?? "delete"}
      >
        <Delete />
      </IconButton>
      <span>{title}</span>
    </Stack>
  )
}
